import { useSelector } from "react-redux";
import {
  Link as ReactRouterLink,
  useLocation
} from "react-router-dom";
import { Box, VStack, Link as ChakraLink } from "@chakra-ui/react";
import AnalystBotIcon from "../Icons/AnalystBotIcon";
import FoodKindredProductsIcon from "../Icons/FoodKindredProductsIcon";
import SmeProfileIcon from "../Icons/SmeProfileIcon";
import CompetitiveRisksIcon from "../Icons/CompetitiveRisksIcon";
import EnquiryManagementIcon from "../Icons/EnquiryManagementIcon";
import "./ClientLeftSidebar.scss";
import { useEffect, useState } from "react";
import Chatbot from "../../pages/Client/Chatbot";

const ClientSidebar = () => {
  const location = useLocation();
  const { data } = useSelector((state) => state.userReducer);
  const [page_location, setPageLocation] = useState("analyst-bot");

  useEffect(() => {
    let pathname = location.pathname.split("/");
    setPageLocation(pathname[pathname.length - 1]);
  }, [location.pathname]);

  return (
    <>
      <Box p={"5px"}>
        <VStack align="start" className="left-menu" spacing="2">
          {data?.client && data?.client?._id && (
            <ChakraLink
              className={`icon-container ${
                page_location === "analyst-bot" ? "icon-container-selected" : ""
              }`}
              as={ReactRouterLink}
              to={`/client/${data.client._id}/analyst-bot`}
              title="Analyst Bot"
            >
              <AnalystBotIcon
                color={page_location === "analyst-bot" ? "#FFFFFF" : "#5D5D5D"}
              />
            </ChakraLink>
          )}
          {data?.client && data?.client?.sector && (
            <ChakraLink
              className={`icon-container ${
                page_location === "details" ? "icon-container-selected" : ""
              }`}
              as={ReactRouterLink}
              to={`/sector/${data?.client.sector._id}/details`}
              title={data?.client.sector.sectorName}
            >
              <FoodKindredProductsIcon
                color={page_location === "details" ? "#FFFFFF" : "#5D5D5D"}
              />
            </ChakraLink>
          )}
          {data?.client && data?.client?.sector && (
            <ChakraLink
              className={`icon-container ${
                page_location === "sme-background" ? "icon-container-selected" : ""
              }`}
              as={ReactRouterLink}
              to={`/client/${data?.client._id}/sme-background`}
              title="SME Profile"
            >
              <SmeProfileIcon
                color={page_location === "sme-background" ? "#FFFFFF" : "#5D5D5D"}
              />
            </ChakraLink>
          )}
          {data?.client && data?.client?.sector && (
            <ChakraLink
              className={`icon-container ${
                page_location === "competitive-risks" ? "icon-container-selected" : ""
              }`}
              as={ReactRouterLink}
              to={`/client/${data?.client._id}/competitive-risks`}
              title="Competitive Risks"
            >
              <CompetitiveRisksIcon
                color={page_location === "competitive-risks" ? "#FFFFFF" : "#5D5D5D"}
              />
            </ChakraLink>
          )}
          {data?.client && data?.client?.sector && (
            <ChakraLink
              className={`icon-container ${
                page_location === "enquiry-management" ? "icon-container-selected" : ""
              }`}
              as={ReactRouterLink}
              to={`/client/${data?.client._id}/enquiry-management`}
              title="Enquiry Management"
            >
              <EnquiryManagementIcon
                color={page_location === "enquiry-management" ? "#FFFFFF" : "#5D5D5D"}
              />
            </ChakraLink>
          )}
          {data?.client && data?.client?.sector && (
            <ChakraLink
              className={`icon-container ${
                page_location === "goal-setting" ? "icon-container-selected" : ""
              }`}
              as={ReactRouterLink}
              to={`/client/${data?.client._id}/goal-setting`}
              title="Goal Setting"
            >
              {/* <GoalSettingIcon
                color={page_location === "goal-setting" ? "#FFFFFF" : "#5D5D5D"}
              /> */}
            </ChakraLink>
          )}
          {data?.client && data?.client?.sector && (
            <ChakraLink
              className={`icon-container ${
                page_location === "initiatives-review" ? "icon-container-selected" : ""
              }`}
              as={ReactRouterLink}
              to={`/client/${data?.client._id}/initiatives-review`}
              title="Initiatives Review"
            >
              {/* <InitiativesReviewIcon
                color={page_location === "initiatives-review" ? "#FFFFFF" : "#5D5D5D"}
              /> */}
            </ChakraLink>
          )}
          {data?.client && data?.client?.sector && (
            <ChakraLink
              className={`icon-container ${
                page_location === "compliance-calendar" ? "icon-container-selected" : ""
              }`}
              as={ReactRouterLink}
              to={`/client/${data?.client._id}/compliance-calendar`}
              title="Compliance calendar"
            >
              {/* <ComplianceCalendarIcon
                color={page_location === "compliance-calendar" ? "#FFFFFF" : "#5D5D5D"}
              /> */}
            </ChakraLink>
          )}
        </VStack>
      </Box>
      {page_location === "analyst-bot" && <Chatbot />}
    </>
  );
};

export default ClientSidebar;